// Guest Analytics - Singleton instance

import { GuestAnalyticsClient } from './guestAnalyticsClient'
import { GuestAnalyticsConfig } from './types'

let instance: GuestAnalyticsClient | null = null

export function getGuestAnalyticsClient(
  config: GuestAnalyticsConfig
): GuestAnalyticsClient {
  if (!instance) {
    instance = new GuestAnalyticsClient(config)
  }
  return instance
}

export * from './types'
export { GuestAnalyticsClient }
